var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelStarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "#FFF",
  rx: 2,
  transform: "translate(3 3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M19.005 3C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.893 3 4.995 3ZM12 5.571 10.714 9.43H5.571l3.983 3.366L8.221 17.2 12 14.57l3.779 2.63-1.333-4.406 3.983-3.366h-5.143z"
}))));
export default SvgGemChannelStarFilled;